/**
 * Confidentialité — masquage du nom des chirurgies à la caisse.
 *
 * Quand le masque est actif, le nom de la chirurgie (ex. « PROSTATECTOMIE RADICALE »)
 * est remplacé par « Acte opératoire » dans les en-têtes de groupes des factures
 * (paiement, vue facture, pro-facture).
 *
 * Le choix est conservé en localStorage (par poste / navigateur), sans migration BDD.
 */
const STORAGE_KEY = 'caisse_masque_chirurgie'

export const masqueChirurgieMixin = {
    data() {
        return {
            chirurgie_masquee: false
        }
    },

    created() {
        try {
            this.chirurgie_masquee = (localStorage.getItem(STORAGE_KEY) === '1')
        } catch (e) {
            this.chirurgie_masquee = false
        }
    },

    methods: {
        toggleMasqueChirurgie() {
            this.chirurgie_masquee = !this.chirurgie_masquee
            try {
                localStorage.setItem(STORAGE_KEY, (this.chirurgie_masquee) ? '1' : '0')
            } catch (e) {
                // localStorage indisponible : le choix reste valable pour la session en cours
            }
        },

        /**
         * En-tête de groupe : « <Chirurgie | Acte opératoire> - <Groupe prestation> »
         * @param {Object} group
         * @returns {String}
         */
        libelleEnteteGroupe(group) {
            const chirurgie = (group.chirurgie)
                ? ((this.chirurgie_masquee) ? 'Acte opératoire' : group.chirurgie) + ' - '
                : ''

            return chirurgie + ' ' + group.group_prestation
        },

        /**
         * Nom de la chirurgie seul (tableaux proforma imbriqués)
         * @param {Object} group
         * @returns {String}
         */
        libelleChirurgie(group) {
            return (this.chirurgie_masquee) ? 'Acte opératoire' : group.chirurgie
        }
    }
}
